/*
 * This file is part of the Sylius package.
 *
 * (c) Paweł Jędrzejewski
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import $ from 'jquery';

const handleProductOptionsChange = function handleProductOptionsChange() {
  $('[name*="sylius_add_to_cart[cartItem][variant]"]').on('change', () => {
    let selector = '';

    $('#sylius-product-adding-to-cart select[data-option]').each((index, element) => {
      const select = $(element);
      const option = select.find('option:selected').val();
      selector += `[data-${select.attr('data-option')}="${option}"]`;
    });

    const price = $('#sylius-variants-pricing').find(selector).attr('data-value');

    if (price !== undefined) {
      $('#product-price').text(price);
      $('button[type=submit]').removeAttr('disabled');
    } else {
      $('#product-price').text($('#sylius-variants-pricing').attr('data-unavailable-text'));
      $('button[type=submit]').attr('disabled', 'disabled');
    }
  });
};

const handleProductVariantsChange = function handleProductVariantsChange() {
  $('[name="sylius_add_to_cart[cartItem][variant]"]').on('change', (event) => {
    const image = $(event.currentTarget).parents('.product').find('.prod-img');
    const imageTh = $(event.currentTarget).parents('.product').find('.prod-th');
    const ean = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('code');
    const price = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').text();
    const priceWithoutTax = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('price-without-tax');
    const priceWithTax = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('price-with-tax');
    const originalPriceWithoutTax = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('original-price-without-tax');
    const originalPriceWithTax = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('original-price-with-tax');
    const productUnit = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('unit');
    const productSalable = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('salable');
    const productSalableCss = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('salable-css');
    const imageOriginal = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('image-original-url');
    const imageThumbnail = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('image-thumbnail-url');
    const hasDiscount = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('has-discount');
    const label = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('label');

    let promotionsLabel = $(event.currentTarget).parents('tr').find('.sylius-product-variant-price').data('promotions-label');
    try {
      promotionsLabel = JSON.parse(promotionsLabel);
    } catch (error) {
      promotionsLabel = '';
    }

    if (hasDiscount) {
      $('.product__price_row').addClass('product__price_action_row');
      $('.product__original_price_row').css("display", "table-row");
      $('#price-label').text(label);
    } else {
      $('.product__price_row').removeClass('product__price_action_row');
      $('.product__original_price_row').css("display", "none");
      $('#price-label').text(label);
    }
    $(image).attr("href", imageOriginal);
    $(imageTh).attr("src", imageThumbnail);
    $('#product-price').text(priceWithTax);
    $('#product-price-without-tax').text(priceWithoutTax);
    $('#original-product-price').text(originalPriceWithTax);
    $('#original-product-price-without-tax').text(originalPriceWithoutTax);
    $('.sylius-unit').text(productUnit);
    let syliusProductSalableElement = $('.sylius-product-salable');
    syliusProductSalableElement.text(productSalable);
    syliusProductSalableElement.removeClass('out-of-stock in-stock').addClass(productSalableCss);
    $('.sylius-ean').text(ean);
    $('.product_show_tags').html(promotionsLabel);
  });
};

const handleBoxProductVariantsChange = function handleBoxProductVariantsChange() {
    $('.sylius_add_to_cart_variants').on('change', (event) => {
    let lastItem = $(event.currentTarget).closest('.last__item');
    if (!lastItem.length > 0) {
      lastItem = $(event.currentTarget).closest('.list__item');
    }
    const productId = $(lastItem).data('product-id');
    const selected = $(event.currentTarget).find(':selected');
    const priceWithTax = selected.data('price-with-tax');
    const productUnit = selected.data('unit');
    const originalPriceWithTax = selected.data('original-price-with-tax');
    const productSalable = selected.data('salable');
    const productSalableCss = selected.data('salable-css');
    const hasDiscount = selected.data('has-discount');
    let promotionsLabel = selected.data('promotions-label');
      try {
        promotionsLabel = JSON.parse(promotionsLabel);
      } catch (error) {
        promotionsLabel = '';
      }
    $(lastItem).find('.product_box_tags').html(promotionsLabel);

    if (hasDiscount) {
      $(lastItem).find('#price_with_tax_row_'+ productId).addClass('price-with-action');
      $(lastItem).find('#price_label_'+ productId).removeClass('no-action-price');
      $(lastItem).find('#original_price_row_'+ productId).css('display', 'block');
    } else {
      $(lastItem).find('#price_with_tax_row_'+ productId).removeClass('price-with-action');
      $(lastItem).find('#price_label_'+ productId).addClass('no-action-price');
      $(lastItem).find('#original_price_row_'+ productId).css('display', 'none');
    }
    $(lastItem).find('#price_with_tax_'+ productId).text(priceWithTax);
    $(lastItem).find('#original_price_with_tax_'+ productId).text(originalPriceWithTax);
    $(lastItem).find('#product_unit_'+ productId).text(productUnit);
      let salableIdElement = $(lastItem).find('#salable_'+ productId);
      salableIdElement.text(productSalable);
    salableIdElement.removeClass('in-stock in-stock').addClass(productSalableCss);
    const imageTh = $(lastItem).find('.prod-th');
    const imageThumbnail = selected.data('image-thumbnail-url');
    $(imageTh).attr("src", imageThumbnail);
    });
};

$.fn.extend({
  variantPrices() {
    if ($('#sylius-variants-pricing').length > 0) {
      handleProductOptionsChange();
    } else if ($('#sylius-product-variants').length > 0) {
      handleProductVariantsChange();
    }
    if ($('.sylius_add_to_cart_variants').length > 0) {
      handleBoxProductVariantsChange();
    }
  },
});
